<template>
    <v-sheet width="100%" class="py-1 px-4 rfq-sheet">
        <v-row no-gutters class="rfq-inner-row">
            <v-col xs="0" sm="0" md="0" lg="1" xl="1" />

            <v-col xs="12" sm="12" md="12" lg="10" xl="10" class="pt-2 d-flex flex-column rfq-content-col">
                <div class="d-flex align-center mb-2" style="gap: 8px;">
                    <span class="text-h5 font-weight-light mr-2">{{ $t('broker.activePositions.orderLog') }}</span>
                    <base-filter
                        :groups="statusFilterGroups"
                        :value="{ status: localFilter }"
                        :clearable="false"
                        @change="onStatusFilterChange"
                    />
                    <v-spacer />
                    <v-btn small outlined @click="$emit('export-orderlog')" class="text-capitalize">
                        {{ $t('plexusOrderLog.export') }}
                    </v-btn>
                    <!-- <v-btn small outlined color="error" @click="$emit('clear-orderlog')" class="text-capitalize">
                        Clear
                    </v-btn>-->
                </div>

                <v-card outlined class="rfq-card pa-0">
                    <base-data-table :loading="tableLoading" dense :headers="rfqHeaders" :items="rfqElements"
                        class="elevation-1 rfq-data-table " style="cursor: pointer;"
                        @click:row="openDetail">

                        <template #[`item.bank_label`]="{ item }">
                            <span :class="isDisabled(item)">{{ item.bank_label || '-' }}</span>
                        </template>
                        <template #[`item.rfq_amount`]="{ item }">
                            <span :class="isDisabled(item)" >{{ item.rfq_amount || '-'
                            }}</span>
                        </template>
                        <template #[`item.rfq_total`]="{ item }">
                            <span :class="isDisabled(item)">{{ item.rfq_total || '-'
                            }}</span>
                        </template>
                        <template #[`item.rfq_deal_px`]="{ item }">
                            <span :class="isDisabled(item)">{{ item.rfq_deal_px || '-'
                            }}</span>
                        </template>
                        <template #[`item.rfq_deal_time`]="{ item }">
                            <span :class="isDisabled(item)">{{ item.rfq_deal_time || '-'
                            }}</span>
                        </template>

                        <template #[`item.rfq_maturity`]="{ item }">
                            <span :class="isDisabled(item)">{{ (item.rfq_maturity || '-').toUpperCase() }}</span>
                        </template>

                            <template #[`item.rfq_ccy`]="{ item }">
                            <span :class="isDisabled(item)">{{ (item.rfq_ccy || '-').toUpperCase() }}</span>
                        </template>

                        <template #[`item.rfq_spread_ptax`]="{ item }">
                            <span :class="isDisabled(item)">{{ item.rfq_spread_ptax || '-' }}</span>
                        </template>

                        <template #[`item.rfq_spotsett`]="{ item }">
                            <span :class="isDisabled(item)">{{ item.rfq_spotsett || '-' }}</span>
                        </template>

                        <template #[`item.rfq_side`]="{ item }">
                            <span :class="[isDisabled(item),
                            {
                                'alive--text': item.rfq_side === 'BUY',
                                'orangeColor--text': item.rfq_side === 'SELL'
                            }]">
                                {{ item.rfq_side ? item.rfq_side.toUpperCase() : '-' }}
                            </span>
                        </template>

                        <template #[`item.rfq_status`]="{ item }">
                            <span  :class="[isDisabled(item),{
                                'alive--text': item.rfq_status === 'DEAL',
                            }]">
                                {{ item.rfq_status || '-' }}
                            </span>
                        </template>

                        <template #[`item.rfq_id`]="{ item }">
                            <div class="rfq-wrapper d-flex align-center">
                                <span :class="isDisabled(item)">{{
                                    `${item.rfq_id.slice(0, 10)}...`
                                    }}</span>
                                <v-icon small class="copy-icon ml-1 clickable-row"
                                    @click.stop="copyToClipboardText(item.rfq_id)">
                                    mdi-content-copy
                                </v-icon>
                            </div>
                        </template>

                        <template #[`item.action`]="{ item }">
                            <v-btn :disabled="item.rfq_status !== 'DEAL'" icon @click.stop="downloadDoc(item)">
                                <v-icon small>mdi-download</v-icon>
                            </v-btn>
                        </template>
                    </base-data-table>
                </v-card>
            </v-col>

            <v-col xs="0" sm="0" md="0" lg="1" xl="1" />
        </v-row>

        <OrderDetailModal v-model="showDetailModal" :item="selectedItem" />
    </v-sheet>
</template>

<script>
import { useSnackbarStore } from "@/store";
import { copyToClipboard as copyText } from "@/utils/utils.js";
import { convertCurrencyToNumber } from "@/utils/utils.js";
import { generateImportacaoPDF } from '@/utils/exportPDF.js'
import { mapActions } from "pinia";
import OrderDetailModal from './OrderDetailModal.vue';

export default {
    components: { OrderDetailModal },
    props: {
        tableLoading: { type: Boolean, default: false },
        rfqHeaders: { type: Array, default: () => [] },
        rfqElements: { type: Array, default: () => [] },
        orderlogFilter: { type: String, default: 'all' },
    },
    data() {
        return {
            localFilter: this.orderlogFilter,
            showDetailModal: false,
            selectedItem: {},
        }
    },
    watch: {
        orderlogFilter(val) {
            this.localFilter = val
        },
    },
    computed: {
        statusFilterGroups() {
            return [
                {
                    key: "status",
                    multiple: false,
                    mandatory: true,
                    options: [
                        { value: "all", label: this.$t('plexusOrderLog.filterAll') },
                        { value: "DEAL", label: this.$t('plexusOrderLog.filterDeal') },
                        { value: "DECLINED", label: this.$t('plexusOrderLog.filterDeclined') },
                    ],
                },
            ];
        },
    },
    methods: {
        ...mapActions(useSnackbarStore, ["open"]),
        onStatusFilterChange({ value }) {
            this.localFilter = value;
            this.$emit('update:orderlog-filter', value);
        },
        openDetail(item) {
            this.selectedItem = item;
            this.showDetailModal = true;
        },
        copyToClipboardText(text) {
            copyText(text)
            this.open(this.$t('plexusOrderLog.idCopied'))
        },
        isDisabled(item){
            return item?.rfq_status === "DEAL" ? "font-weight-bold" : "font-weight-light"
        },
        async downloadDoc(item) {
            if (item.rfq_status.toUpperCase() !== 'DEAL') return;
            await generateImportacaoPDF({
                fileName: String(item.rfq_security),
                data: {
                    ...item,
                    rfq_amount_number: convertCurrencyToNumber(item.rfq_amount),
                    rfq_deal_px: convertCurrencyToNumber(item.rfq_deal_px),
                },
            });
        }
    }
}
</script>

<style scoped>
.rfq-sheet {
    background-color: transparent;
}

/* Force table to fill its container and never overflow horizontally */
.rfq-data-table :deep(.v-data-table__wrapper) {
    overflow-x: hidden !important;
    overflow-y: visible !important;
}

.rfq-data-table :deep(.v-data-table__wrapper > table) {
    table-layout: fixed !important;
    width: 100% !important;
}

/* Fluid font + minimal padding so all columns squeeze gracefully */
.rfq-data-table :deep(.v-data-table__wrapper > table th),
.rfq-data-table :deep(.v-data-table__wrapper > table td) {
    font-size: clamp(9px, 1.05vw, 13px) !important;
    padding: 0 clamp(3px, 0.45vw, 8px) !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.3;
}

/* Action column: icon only, fixed narrow */
.rfq-data-table :deep(.v-data-table__wrapper > table th:last-child),
.rfq-data-table :deep(.v-data-table__wrapper > table td:last-child) {
    padding: 0 2px !important;
    text-align: center;
}

/* Shrink the download icon button at small sizes */
.rfq-data-table :deep(.v-data-table__wrapper > table td:last-child .v-btn) {
    width: 24px !important;
    height: 24px !important;
}

/* ID cell: already truncated in template, keep copy icon aligned */
.rfq-wrapper {
    display: flex;
    align-items: center;
    overflow: hidden;
}

.rfq-wrapper span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

@media (max-width: 1200px) {
    .rfq-data-table :deep(.v-data-table__wrapper > table th),
    .rfq-data-table :deep(.v-data-table__wrapper > table td) {
        padding: 0 3px !important;
    }
}

@media (max-width: 960px) {
    .rfq-data-table :deep(.v-data-table__wrapper > table th),
    .rfq-data-table :deep(.v-data-table__wrapper > table td) {
        padding: 0 2px !important;
        line-height: 1.2;
    }
}
</style>